import { Route, Routes, RoutesProps } from "react-router-dom";
import { FC, lazy } from "react";

const Regist = lazy(()=>import("@/views/regist"));
const Success = lazy(()=>import("@/views/success"));
const NofindPage = lazy(()=>import("@/views/noFindPage"));

interface WabaCaptchaRouterProps extends RoutesProps {};

const WabaCaptchaRouter:FC<WabaCaptchaRouterProps> = (props)=>{
    return(
        <Routes {...props}>
            <Route path="/" element={<Regist/>}/>
            <Route path="/success" element={<Success/>}/>
            <Route path="/*" element={<NofindPage />} />
        </Routes>
    )
}

export default WabaCaptchaRouter;